// extracted by mini-css-extract-plugin
export var webhotLifePanorama = "index-module--webhotLifePanorama--JrH9-";
export var webhotLifePartner = "index-module--webhotLifePartner--y-bep";